import PropTypes from "prop-types";

const _RecentPosts = PropTypes.shape({
  acf_fc_layout: PropTypes.string,
  recent_posts_count: PropTypes.number,
  recent_posts_in_grid: PropTypes.bool,
  recent_posts_type: PropTypes.string,
});

export const RecentPostsPropTypes = {
  data: PropTypes.oneOfType([_RecentPosts, PropTypes.any]),
};
